import { useEffect, useState } from 'react';
import { APP_STORE_URL, DownloadTiles, PLAY_STORE_URL } from '../components/DownloadTiles';

// Destination for share links (e.g. the in-app "recruit a friend" flow).
// A share link can't know the recipient's platform ahead of time, so this
// page sniffs it client-side on arrival: mobile visitors get sent straight
// to the matching store, desktop visitors (who can't tap a store link on
// their own device) get the QR tiles to scan with their phone instead.
export function GetApp() {
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isAndroid = /Android/.test(ua);
    if (isIOS) {
      setRedirecting(true);
      window.location.replace(APP_STORE_URL);
    } else if (isAndroid) {
      setRedirecting(true);
      window.location.replace(PLAY_STORE_URL);
    }
  }, []);

  return (
    <section className="install-section">
      <h2>Ladda ner appen</h2>
      <p className="install-desc">
        {redirecting ? 'Skickar dig till appbutiken…' : 'Gratis · Tillgänglig på iOS och Android'}
      </p>
      <DownloadTiles />
    </section>
  );
}
